<template>
  <div
    style="text-align: right;"
  >
    <el-dropdown
      ref="dropDown"
      size="small"
      @command="handleAction"
    >
      <el-button
        size="mini"
        class="el-dropdown-link"
        @click.stop="toggleDropDown"
      >
        <i :class="!buttonLoader ? 'el-icon-more' : 'el-icon-loading'" />
      </el-button>
      <el-dropdown-menu slot="dropdown">
        <el-dropdown-item
          v-can="'customerreturnorder.create'"
          :command="copyCustomerReturnOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-document-copy" /> Másolás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="customerReturnOrder.status !== 'recorded' && customerReturnOrder.status !== 'cancelled' && customerReturnOrder.receipt_file"
          v-can="'customerreturnorder.view'"
          :command="openReceipt"
          :disabled="buttonLoader"
        >
          <i class="el-icon-printer" /> Bizonylat nyomtatás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="customerReturnOrder.status === 'recorded'"
          v-can="'customerreturnorder.update'"
          :command="sendOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-check" /> Termékek visszavétele
        </el-dropdown-item>
        <el-dropdown-item
          v-can="'customerreturnorder.update'"
          :command="updateRcustomerReturnOrder"
          :disabled="buttonLoader"
        >
          <i class="el-icon-edit" /> Módosítás
        </el-dropdown-item>
        <el-dropdown-item
          v-if="customerReturnOrder.status === 'recorded'"
          v-can="'customerreturnorder.delete'"
          :command="openDeleteConfirmation"
          :disabled="buttonLoader"
        >
          <i class="el-icon-delete" /> Törlés
        </el-dropdown-item>
        <el-dropdown-item
          :command="exportExcel"
          :disabled="buttonLoader"
        >
          <i class="el-icon-download" /> Excel exportálás
        </el-dropdown-item>
      </el-dropdown-menu>
    </el-dropdown>
  </div>
</template>

<script>
  export default {
    props: ['customerReturnOrder'],
    data() {
      return {
       buttonLoader: false,
        deleteConfirmVisible: false,
      };
    },

    methods: {
      async deleteCustomerReturnOrder() {
        this.buttonLoader = true;
        this.deleteConfirmVisible = false;
        try {
          await this.$store.dispatch('customerReturnOrder/delete', this.customerReturnOrder.id);
          this.$store.dispatch('customerReturnOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async updateRcustomerReturnOrder() {
        this.$router.push('/sales/customer-return-orders/update/' + this.customerReturnOrder.id);
      },
      async sendOrder() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('customerReturnOrder/send', this.customerReturnOrder.id);
          this.$store.dispatch('customerReturnOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async cancelCustomerReturnOrder() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('customerReturnOrder/cancel', this.customerReturnOrder.id);
          this.$store.dispatch('customerReturnOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      async undoCancelCustomerReturnOrder() {
        this.buttonLoader = true;
        try {
          await this.$store.dispatch('customerReturnOrder/undoCancel', this.customerReturnOrder.id);
          this.$store.dispatch('customerReturnOrder/fetchAll');
        } catch (e) {
        }
        this.buttonLoader = false;
      },
      copyCustomerReturnOrder() {
        this.$router.push('/sales/customer-return-orders/add/' + this.customerReturnOrder.id);
      },
      openDeleteConfirmation() {
        this.$confirm('Ez a folyamat nem visszafordítható és a kapcsolódó elemek is törölve lesznek.', 'Biztosan törölni szeretnéd?', {
          confirmButtonText: 'Igen',
          cancelButtonText: 'Mégse',
          type: 'warning',
        })
        .then(() => {
          this.deleteCustomerReturnOrder();
        })
        .catch(() => {
          this.$router.replace('/sales/customer-return-orders');
        });
      },
      handleAction(action) {
        action();
      },
      toggleDropDown() {
        this.$refs['dropDown'].visible = !this.$refs['dropDown'].visible;
      },
      openReceipt() {
        if (this.customerReturnOrder.receipt_file && this.customerReturnOrder.receipt_file.path) {
          window.open(this.customerReturnOrder.receipt_file.path);
        }
      },
      async exportExcel() {
        try {
          this.buttonLoader = true;
          const excel = await axios({
            url: 'api/customer-return-orders/' + this.customerReturnOrder.id + '/export',
            method: 'GET',
            responseType: 'blob',
          });
          saveAs(excel, 'customer_return_order_items.xlsx');
        } catch (e) {
        }
        this.buttonLoader = false;

      },
    }
  };
</script>
